<template>
    <div>
        <div class="banner">
            <span>{{$t("about.banner")}}</span>
        </div>
        <div class="section-wrap ">
            <tabnav :tab="tab"></tabnav>
            <div class="tab-content ">
                <div :class="'tab1 '+(tab==1?'':'hide')">
                    <div class=" text1">
                        {{$t("about.t1")}}
                    </div>


                    <div class="tech-table-w pc">
                        <div class="tech-table table">
                            <div class="tech-cell table-cell tech-img1 icon-tri icon-tri-bottom" >
                            </div>
                            <div class="tech-cell table-cell ">
                                <p class="tech-title c-333">{{$t("about.cell[0].t1")}}</p><p class="tech-label c-666"></p>
                                <div class="tech-text c-666">{{$t("about.cell[0].t2")}}</div>
                            </div>

                            <div class="tech-cell table-cell tech-img3 icon-tri icon-tri-bottom" >
                            </div>
                        </div>
                        <div class="tech-table table">
                            <div class="tech-cell table-cell ">
                                <p class="tech-title c-333">{{$t("about.cell[1].t1")}}</p><p class="tech-label c-666"></p>
                                <div class="tech-text c-666">{{$t("about.cell[1].t2")}}</div>
                            </div>

                            <div class="tech-cell table-cell tech-img2 icon-tri icon-tri-top" >
                            </div>
                            <div class="tech-cell table-cell ">
                                <p class="tech-title c-333">{{$t("about.cell[2].t1")}}</p><p class="tech-label c-666"></p>
                                <div class="tech-text c-666">{{$t("about.cell[2].t2")}}</div>
                            </div>
                        </div>

                    </div>
                    <div class="tech-table-w mobile">
                        <div class="tech-table table">
                            <div class="tech-cell table-cell tech-img1 icon-tri icon-tri-right" >
                            </div>
                            <div class="tech-cell table-cell ">
                                <p class="tech-title c-333">{{$t("about.cell[1].t1")}}</p><p class="tech-label c-666"></p>
                                <div class="tech-text c-666">{{$t("about.cell[1].t2")}}</div>
                            </div>
                        </div>
                        <div class="tech-table table">

                            <div class="tech-cell table-cell ">
                                <p class="tech-title c-333">{{$t("about.cell[0].t1")}}</p><p class="tech-label c-666"></p>
                                <div class="tech-text c-666">{{$t("about.cell[0].t2")}}</div>
                            </div>
                            <div class="tech-cell table-cell tech-img2 icon-tri icon-tri-left" >
                            </div>
                        </div>
                        <div class="tech-table table">
                            <div class="tech-cell table-cell tech-img3 icon-tri icon-tri-right" >
                            </div>
                            <div class="tech-cell table-cell ">
                                <p class="tech-title c-333">{{$t("about.cell[2].t1")}}</p><p class="tech-label c-666"></p>
                                <div class="tech-text c-666">{{$t("about.cell[2].t2")}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="about-content">
                        <div class="about-title rela">
                            {{$t("about.t2")}}
                        </div>
                        <div class="about-text" v-html='$t("about.c2")'></div>
                    </div>
                    
                    <div class="about-content">
                        <div class="about-title rela">
                            {{$t("about.t3")}}
                        </div>
                        <div class="about-text" v-html='$t("about.c3")'></div>
                    </div>
                    
                    <div class="about-content">
                        <div class="about-title rela">
                            {{$t("about.t4")}}
                        </div>
                        <div class="about-text" v-html='$t("about.c4")'></div>
                        <div class="about-t-v">{{ $t('about.c4_1') }}</div>
                        <ul class="clearfix about-v">
                            <li class="fl">{{ $t('about.c4_01') }}</li>
                            <li class="fl">{{ $t('about.c4_02') }}</li>
                            <li class="fl">{{ $t('about.c4_03') }}</li>
                        </ul>
                    </div>

                    <!-- <div class="about-title rela">
                        <span>  {{$t("about.t2")}}</span>
                    </div>
                    <div class="about-miles">
                        <ul class="clearfix">
                            <li class="rela c-666 about-miles-li" v-for='item in $t("about.miles")'>
                                <span></span>
                                <p class="about-miles-year">{{item.t1}}</p>
                                <div class="rela about-miles-texts icon-tri">
                                    <p>{{item.t2}}</p>
                                    <div v-html='item.t3'></div>
                                </div>
                            </li>

                        </ul>

                    </div> -->
                </div>

            </div>

        </div>


    </div>
</template>

<script>
    import tabnav from './components/tabnav'
    import { mockAllList } from '@api/mockapi'
    import { mapMutations,mapActions } from 'vuex'


    export default {
        name: 'about',
        components: {tabnav},
        data () {
            return {
                tab:1,
                src:"@/assets/images/tech/img1.png",
                listQuery:{
                    page:1,
                    totalPage:2
                },
                curImg:'',
                showLayerBig:false,
                patent:[[{src: require('@/assets/images/tech/patent/4.jpg'),title:'韩国专利133',label:''},{src:require('@/assets/images/tech/patent/5.jpg'),title:'韩国专利405',label:''},
                    {src:require('@/assets/images/tech/patent/6.jpg'),title:'韩国专利958',label:''}, {src:require('@/assets/images/tech/patent/7.jpg'),title:'实用新型',label:'防滑鞋底 2009'},
                    {src:require('@/assets/images/tech/patent/8.jpg'),title:'实用新型',label:'防滑鞋底 2010'}, {src:require('@/assets/images/tech/patent/9.jpg'),title:'实用新型',label:'防滑鞋底 2012'},
                    {src:require('@/assets/images/tech/patent/10.jpg'),title:'实用新型',label:'一种高蜂窝后鞋跟 2008'},{src:require('@/assets/images/tech/patent/11.jpg'),title:'实用新型',label:'一种平蜂窝后鞋跟 2008'},
                    {src:require('@/assets/images/tech/patent/12.jpg'),title:'外观设计',label:'防滑童鞋 2014'},{src:require('@/assets/images/tech/patent/13.jpg'),title:'外观设计',label:'防滑拖鞋 2014'},
                    {src:require('@/assets/images/tech/patent/14.jpg'),title:'外观设计',label:'防滑拖鞋二 2014'},{src:require('@/assets/images/tech/patent/15.jpg'),title:'外观设计',label:'防滑拖鞋一 2014'},],
                    [
                        {src:require('@/assets/images/tech/patent/16.jpg'),title:'外观设计',label:'防滑鞋 2013'},{src:require('@/assets/images/tech/patent/17.jpg'),title:'外观设计',label:'拖鞋 2013'},
                        {src:require('@/assets/images/tech/patent/18.jpg'),title:'外观设计',label:'橡胶板 2013'},{src:require('@/assets/images/tech/patent/19.jpg'),title:'外观设计',label:'鞋底 2009'},
                        {src:require('@/assets/images/tech/patent/20.jpg'),title:'의장등록399',label:''},{src:require('@/assets/images/tech/patent/21.jpg'),title:'의장등록400',label:''},]],

            }
        },
        created () {
        },
        mounted(){
            this.getList()

        },
        methods: {
            getList() {

            }
        }
    }
</script>
<style lang="stylus" scoped>
    @import "~@/assets/css/public.styl"
    .English{
        .tech-text{line-height:1.2}
        .tech-cell{padding:.2rem .24rem 0}
        .about-content .about-v>li{width:100%;text-align:left;padding-left:.24rem}
    }

    .realize-more
        user-select none;cursor pointer
    h2,h3,h4,h5,h6,p{
        margin: 0
    }

    .banner{height:280px;background :url("~@/assets/images/about/banner.jpg") no-repeat center/auto 100%;}
    .tab-nav>div{width:25%;}
    .tab-content{margin-bottom: 1.45rem;}
    .text1{font-size:.16rem;color:#666666;width:7rem;margin:0 auto;line-height:.32rem;padding:.56rem 0 .63rem;text-align:justify;}

    .video{height:4.4rem;width:100%;display: block; }
    .video{background: url("~@/assets/images/tech/video.png") no-repeat center/cover;border-radius .05rem;}
    .tech-table-w{padding:0 .5rem;padding-bottom 1.2rem;}
    .tech-table{width:100%;background :#f8f8f8;min-height:2.67rem;}
    .tech-cell{width:33.33%;vertical-align middle;padding:0.3rem .38rem;position relative;}
    .tech-title{font-size:.24rem;}
    .tech-label{width:.32rem;height:.03rem;background:$standardColor;margin-bottom: .14rem; margin-top: .1rem;}
    .tech-text{font-size:.14rem;line-height :.24rem;text-align:justify;}
    .tech-img1{background: url("~@/assets/images/about/01.png") no-repeat center/cover;}
    .tech-img2{background: url("~@/assets/images/about/02.png") no-repeat center/cover;}
    .tech-img3{background: url("~@/assets/images/about/03.png") no-repeat center/cover;}

    .tech-ul{padding-top:.2rem;}

    .tab1{background:#fff;}
        
    .about-content
        padding:0 .9rem .8rem;
        .about-title{color:#333;font-size :.24rem;text-align center;line-height: 1;rela();margin-bottom:.4rem}
        .about-title:before{content:'';abso();left:0;width:.32rem;height:.03rem;background:$standardColor;right:0;margin: auto ;bottom:-.16rem}
        .about-text{font-size:.16rem;color:#595757;line-height:1.8;text-align:justify;}
        .about-t-v{font-size:.2rem;padding:.2rem 0 .1rem;color:#333}
        .about-v{color:#fff;font-size:.16rem;}
        .about-v>li
            width:33.33%;text-align :center;background:#fdd933;height:.46rem;line-height:.46rem;color:$standardColor;font-weight:bold;
            &:first-child{background:#fdcf00 }
            &:last-child{background:#fde056}
            

    .about-title span{position:relative;padding:0 1em;background :#fff;}
        .about-miles{padding:0.8rem .5rem .5rem;}
        .about-miles-li{width:14.28%;fl();rela();text-align :center;margin:2.8rem 0;height:.55rem;
            &:hover{
    .about-miles-texts{background :#4285c121;}
            }
        &:nth-child(2n-1){
             .about-miles-texts{bottom:1.1rem;
                 &:after{border-top-color:#f8f8f8;top:100%;left:50%;margin-left:-.11rem;}
             }
            &:hover .about-miles-texts{bottom:1.2rem;
    &:after{border-top-color:#4285c121;}
            }

            }
            &:nth-child(2n){
                .about-miles-texts{top:.7rem;
                    &:after{border-bottom-color:#f8f8f8;bottom:100%;left:50%;margin-left:-.11rem;}
                }
                &:hover .about-miles-texts{top:.8rem;
                    &:after{border-bottom-color:#4285c121;}}
            }
            &:first-child:before{width:50%;left:50%;}
            &:before{content:'';abso();width:100%;height:1px;background :#ccc;left:0;top:.08rem;}
            &:hover .about-miles-year{color:$standardColor;font-size:.24rem;}
            &:hover span:after{
                content :'';width:.14rem;height :.14rem;background :$standardColor;border:.03rem solid #fff;border-radius :50%;abso();top:0;left:0;
            }
        }

    .about-miles-li span{display:inline-block;width:.14rem;height :.14rem;border:1px solid #ccc;border-radius :50%;rela();box-sizing :content-box;background #fff;


    }
            .about-miles-texts{background:#f8f8f8;abso();text-align :left;padding:.2rem;min-height:2.3rem;
                p{font-size:.32rem;color:#000;}
                div{font-size:.14rem;line-height:.24rem;}

    }
                .about-miles-year{font-size:.16rem;
                }
    @media screen and (max-width: 768px){
        .section-wrap{padding:0;}
        .banner{height:3.7rem;background url("~@/assets/images/about/m-banner.jpg") no-repeat center/auto 100%;}
        .tab-content{background:#f8f8f8;margin-bottom: 0;}
        .text1{font-size:.26rem;line-height:.56rem;padding:.55rem 0 .3rem;}
        .video{border-radius:0;}
        .tech-title{font-size:.32rem;}
        .tech-cell{padding: 0.3rem 0.24rem;}
        .tech-table{min-height :5.65rem;}
        .tech-label{width:.32rem;height:.03rem;background:$standardColor;margin-bottom: .1rem; margin-top: .1rem;}
        .tech-text{font-size:.24rem;line-height .48rem;}
        .tech-table-w{padding:0 .24rem .6rem;}
        .tech-img1{background: url("~@/assets/images/about/01-m.jpg") no-repeat center/cover;}
        .tech-img2{background: url("~@/assets/images/about/02-m.jpg") no-repeat center/cover;}
        .tech-img3{background: url("~@/assets/images/about/03-m.jpg") no-repeat center/cover;}
        .tech-ul{width:93.33%;margin:0 auto;}
        .tab1{padding-bottom:.32rem}
        .about-content{
            padding:0 .4rem .4rem;
            .about-title{font-size: .32rem; margin-top: .4rem;}
            .about-text{font-size:.24rem}
            .about-t-v{font-size:.28rem;padding-top:.4rem;padding-bottom:.32rem}
            .about-v{font-size:.24rem}
            .about-v>li{width:100%;height:.7rem;line-height:.7rem;text-align:left;padding-left:.32rem}
        }
            
       
        .about-miles{padding:0.7rem 0.24rem .5rem;}
        .about-miles-texts{position:relative;min-height:1.8rem;margin-top: .17rem;
            p{margin-bottom:.12rem;}
        div{font-size:.24rem;    line-height: .32rem;}
        }
        .about-miles-li{float: none; margin: 0;height:auto;text-align :left;padding-left:.5rem;width:100%;padding-bottom :.4rem;padding-right:.16rem;
            span{position:absolute;left:0.17rem;width:.2rem;height:.2rem;}
            &:before{width:1px;height:100%;top:.1rem;left:.28rem;}
            &:first-child:before{width:1px;left:.28rem;}
            &:nth-child(2n-1){
                .about-miles-texts{bottom:0;
                    &:after{left:.1rem;top:auto;bottom:100%;border-bottom-color:#f8f8f8;border-top-color:rgba(255,255,255,0);margin:0;}
                }
                &:hover .about-miles-texts{bottom:0;
        &:after{border-bottom-color:#4285c121;border-top-color:rgba(255,255,255,0);}
                }
            }
            &:nth-child(2n){
                .about-miles-texts{top:0;
                    &:after{left:.1rem;margin:0;}
                }
                &:hover .about-miles-texts{top:0;}
            }
            &:last-child:before{display :none;}
            &:hover span:after{
               width:.2rem;height :.2rem;border:.05rem solid #fff;
            }
            &:hover .about-miles-year{font-size:.32rem;position: relative; top: -.08rem;}

        }
        .about-miles-year{font-size:.24rem;    line-height: 1;}
        .English{
            .tech-title{line-height:1.2;font-size:.28rem}
            .about-content .about-v>li{display:flex;align-items:center;line-height:1.2}
        }

    }
</style>
<style >
    body{background :#f8f8f8}
</style>
